<form [hidden]="requestSent" [formGroup]="form" class="max-w-450px">
  <ib-mat-form-field-wrap
    [formCtrlName]="'amount'"
    [formCtrl]="form.get('amount')"
    [isRightAlignment]="true"
  >
    <mat-form-field class="ib">
      <mat-label
        >{{ 'base.amount' | transloco }},
        {{ (authUser$ | async)?.bankCurrency | uppercase }}</mat-label
      >
      <input
        type="number"
        matInput
        formControlName="amount"
        required
      /> </mat-form-field
  ></ib-mat-form-field-wrap>

  <p class="mt-40px text-12px">
    {{ 'page.transfer.descr' | transloco }}

    <b>{{ (authUser$ | async)?.bankIban }}</b>
  </p>

  <div class="flex justify-center">
    <button
      mat-button
      type="button"
      [disabled]="form.invalid || loading"
      (click)="submit()"
      class="ib-btn ib-btn-secondary mt-40px"
    >
      {{ 'btn.transfer' | transloco }}
    </button>
  </div>
</form>

<div *ngIf="requestSent">
  <div class="flex justify-center">
    <i class="material-icons text-60px text-success!">check_circle</i>
  </div>
  <p class="mt-40px text-center text-secondary text-16px">
    Thanks! We received your request.
  </p>
</div>
